<template>
  <Card>
    <AjaxForm route="admin/ChangePassword">
      <div class="row">
        <div class="col-12 col-md-4">
          <CustomInput input_style="twoLine" type="password" name="old_pass" label="کلمه عبور پیشین"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput input_style="twoLine" type="password" name="new_pass" label="کلمه عبور جدید"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput input_style="twoLine" type="password" name="confirm_pass" label="تکرار کلمه عبور"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-10 col-md-5 mx-auto">
          <button class="btn btn-info btn-block" type="submit">ویرایش کلمه عبور</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import {mapActions} from "vuex";
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";

export default {
name: "ChangePassword",
  components: {AjaxForm, CustomInput, Card},
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('تغییر کلمه عبور');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>